module.exports = __webpack_public_path__ + "img/lemn_1kl.0fdd4990.jpg";